import { useEffect, useCallback, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';

const CursorTrail = () => {
  const { cursorEffect } = useTheme();
  const particles = useRef([]);
  const animationFrame = useRef(null);

  const createParticle = useCallback((x, y) => {
    const particle = document.createElement('div');
    particle.className = 'cursor-particle';
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.width = '8px';
    particle.style.height = '8px';
    document.body.appendChild(particle);
    
    setTimeout(() => {
      if (particle.parentNode) {
        particle.parentNode.removeChild(particle);
      }
    }, 600);
  }, []);

  useEffect(() => {
    if (!cursorEffect) return;

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    // Check if mobile
    const isMobile = window.innerWidth < 768;
    if (isMobile) return;

    let lastX = 0;
    let lastY = 0;
    let throttle = 0;

    const handleMouseMove = (e) => {
      throttle++;
      if (throttle % 3 !== 0) return; // Throttle for performance

      const dx = e.clientX - lastX;
      const dy = e.clientY - lastY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance > 10) {
        createParticle(e.clientX, e.clientY);
        lastX = e.clientX;
        lastY = e.clientY;
      }
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (animationFrame.current) {
        cancelAnimationFrame(animationFrame.current);
      }
    };
  }, [cursorEffect, createParticle]);

  return null;
};

export default CursorTrail;
